import React from 'react'
import { IconProps } from '../../../common/types'

const ProcessorIcon: React.FC<IconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g className="loadgin-left-outline">
        <g
          fill="#087592"
          fillRule="evenodd"
          className="Vector"
          clipRule="evenodd"
        >
          <path d="M12 6.05c3.869 0 7 3.126 7 6.975a6.97 6.97 0 0 1-3.603 6.1a7 7 0 0 1-1.4.587a1 1 0 0 0 .568 1.918a9 9 0 0 0 1.801-.755A8.97 8.97 0 0 0 21 13.025c0-4.96-4.032-8.974-9-8.974c-1.24 0-2.425.25-3.502.705a1 1 0 1 0 .777 1.843A7 7 0 0 1 12 6.05m.6 15.012a1 1 0 0 0-.944-1.052a7 7 0 0 1-2.645-.673a1 1 0 1 0-.86 1.805a9 9 0 0 0 3.397.865a1 1 0 0 0 1.052-.945M5.208 8.687a1 1 0 0 0-1.33.479a9 9 0 0 0-.85 3.4a1 1 0 1 0 1.998.1c.045-.918.27-1.819.66-2.648a1 1 0 0 0-.478-1.331m1.544 10.432a1 1 0 0 0 .074-1.412a7.1 7.1 0 0 1-1.4-2.345a1 1 0 0 0-1.883.674a9.1 9.1 0 0 0 1.797 3.009a1 1 0 0 0 1.412.074" />
          <path d="M10.194 2.233a.857.857 0 0 0-1.15.385L7.713 5.301a1.086 1.086 0 0 0 .493 1.456l2.691 1.329a.857.857 0 1 0 .758-1.536L9.53 5.5l1.053-2.118a.857.857 0 0 0-.388-1.149Z" />
        </g>
      </g>
    </svg>
  )
}

export default ProcessorIcon
